import { createSelector } from "@reduxjs/toolkit";

export const selectMyListEntries = createSelector(
    [state => state.myList?.entries],
    entries => entries
)